module.exports = __webpack_public_path__ + "static/media/logo.7f0ca3d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 1006
// module chunks = 63